import * as React from 'react';
import classNames from 'classnames/bind';
import iconPaths, { IconName } from './icon-paths';

import css from './icon.module.css';
import { Button } from '../Button';

const cx = classNames.bind(css);

const defaultProps = {
  size: '0.9em',
  as: 'icon',
};

type Props = Omit<React.SVGProps<SVGSVGElement>, 'onClick'> & {
  as?: 'icon' | 'button';
  name: IconName;
  size?: string;
  color?: string;
  onClick?: () => void;
};

export const Icon: React.FC<Props> = props => {
  let styles = {} as React.CSSProperties;

  const { name, size, color, as, className, ...rest } = {
    ...defaultProps,
    ...props,
  };

  if (!(name in iconPaths)) {
    throw new Error(`Icon name "${name}" doesn't exist.`);
  }

  const { viewBox = iconPaths[name].viewBox } = props;

  const { path } = iconPaths[name];

  if (color) {
    styles.color = color;
  }

  const svg = (
    <svg
      className={cx('icon', {
        [className]: !!className && as === 'icon',
        block: as === 'button',
      })}
      width={size}
      viewBox={viewBox}
      fill="none"
      style={styles}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      {path}
    </svg>
  );

  if (as === 'button') {
    return (
      <Button
        variant="clear"
        className={cx('button', className)}
        onClick={() => rest.onClick?.()}
        type="button"
      >
        {svg}
      </Button>
    );
  }

  return svg;
};
